import type { Step } from 'rc-steps';
import type { ComponentProps } from 'react';

type StepProps = ComponentProps<typeof Step>;

export interface StepLineStep extends StepProps {
  key?: number;
}

export interface StepLineColorScheme {
  done: {
    dotColor: string;
    dotBackground: string;
    labelColor: string;
    descriptionColor: string;
    lineColor: string;
  };
  current: {
    dotColor: string;
    dotBackground: string;
    labelColor: string;
    descriptionColor: string;
    lineColor: string;
  };
  next: {
    dotColor: string;
    dotBackground: string;
    labelColor: string;
    descriptionColor: string;
    lineColor: string;
  };
  error: {
    dotColor: string;
    dotBackground: string;
    labelColor: string;
    descriptionColor: string;
    lineColor: string;
  };
}

export type StepLineColor = 'light' | 'dark';

export interface StepLineData {
  currentStep: number;
  steps: StepLineStep[];
  color?: StepLineColor;
  verticalBreakpoint?: number;
}

export interface StepLineProps extends StepLineData {}
